// extracted by mini-css-extract-plugin
export var slider__header = "slider-module--slider__header--h4At2";
export var slider__footer = "slider-module--slider__footer--7WMuO";
export var slider__wrapper = "slider-module--slider__wrapper--m7DNK";
export var slider__container = "slider-module--slider__container--a7yVz";
export var slider__header_left = "slider-module--slider__header_left--zqkFI";